import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { translate } from '../../Services/translation';
import getDistance from 'geolib/es/getDistance';
import {updatePreferedAddress} from '../../Actions/PreferedAddress.action'
import { useSelector,useDispatch } from 'react-redux';
import { distanceFormat } from "../../Services/Formatting.service";
import { googleAnalytics } from '../../Services/googleAnalytics';

const DealerListDetailTags = (props) => {
  const dispatch = useDispatch();
  const selectedInfo = useSelector((state) => state.preferedAddress.selectedAddress);

  const distance = (lat1, lon1, lat2, lon2, unit) => {
    var dist= getDistance(
      { latitude: lat1, longitude: lon1 },
      { latitude: lat2, longitude: lon2}
  );
  return  (dist/1000);
  }
  const getIcon = (assortment, rindex) => {
    if (assortment == "boat_trailers") {
      return <Fragment><i key={'assortment' + rindex} className='icon-trailerboat'></i></Fragment>
    }
    else if (assortment == "open_trailers") {
      return <Fragment><i key={'assortment' + rindex} className='cart__icon'></i></Fragment>
    }
    else if (assortment == "service") {
      return <Fragment><svg key={'assortment' + rindex}> <use href='/ui/images/sprites/brenderup.svg#service'></use></svg></Fragment>
    }
    else if (assortment == "active" && props.isClickAndCollect == "True") {
      return <Fragment><svg><use href="/ui/images/sprites/brenderup.svg#fast-cart"></use></svg></Fragment>
    }
  }

  const addPreferedAddress = (event, address) => {
    if (event.target.checked == true) {
      dispatch(updatePreferedAddress(address));
    }
    else{
      dispatch(updatePreferedAddress(null));
    }
  }
 
  const sendDataLayer = (shopName, click) => {
    googleAnalytics({
      'event': 'dealerLocatorList', 
      'dealer': shopName,
      'click': click
    })
  }

  return (
    <Fragment>
      {props.addresses &&
        props.addresses.map((address, index) => (
          <li className="dealerlist__repeat" key={'_DetailTag_'+index}>
            <div className="row">
              <div className="columns small-12 dealerlist__basic">
                <div className="dealerlist__image">
                  <img src={address.partnericon} alt={address.partnerType} />
                </div>
                <div className="dealerlist__primary">
                  <div>
                  <span className="dealerlist__basic--name">{props.resellername}</span>
                  <span className="dealerlist__basic--km">{distanceFormat.format(distance(props.lat, props.longt, address.latitude, address.longitude, 'K'))} Km</span>
                  </div>
                 
                  <div className="dealerlist__secondary">
                {address.streetName ? (
                        <span>{address.streetName}, </span>
                      ) : ''}
                    {address.zipCode ? (
                        <span>{address.zipCode}, </span>
                      ) : ''}
                      {address.city ? (
                        <span>{address.city} </span>
                      ) : ''}
                    
                      
                </div>
                </div>
                
              
                <div className="dealerlist__icons">

                  {props.productAssortment != null && props.productAssortment.map((assortment, rindex) => (
                    <Fragment> {getIcon(assortment, rindex)} </Fragment>
                  ))
                  }

                </div>

              </div>
              <div className="columns small-12">
                <details className="dealerlist__moreinfo" key={`RESELLERDEALER${index}`}>
                  <summary
                    onClick={() => sendDataLayer(props.resellername, "Open-Dropdown")}
                    className="open-text"
                  >
                    {translate('dealerlocator.contactinfo')}
                    <svg aria-hidden="true">
                      <use href="/ui/images/sprites/brenderup.svg#down-arrow" />
                    </svg>
                  </summary>

                  <ul className="dealerlist__contactinfo">
                    {address.telephone && (
                      <li onClick={() => sendDataLayer(props.resellername, "phone-number")}>
                        <svg aria-hidden="true">
                          <use href="/ui/images/sprites/brenderup.svg#phone" />
                        </svg>
                        <a href={`tel:${address.telephone}`}>{address.telephone}</a>
                      </li>
                    )}

                    {address.homePage && (
                      <li onClick={() => sendDataLayer(props.resellername, "home-page")}>
                        <svg aria-hidden="true">
                          <use href="/ui/images/sprites/brenderup.svg#desktop" />
                        </svg>
                        <a href={address.homePage} target="_blank" rel="noopener noreferrer">
                          {address.homePage}
                        </a>
                      </li>
                    )}

                    {address.email && (
                      <li onClick={() => sendDataLayer(props.resellername, "email")}>
                        <svg aria-hidden="true">
                          <use href="/ui/images/sprites/brenderup.svg#email" />
                        </svg>
                        <a href={`mailto:${address.email}`}>
                          {translate('dealerlocator.sendmessage')}
                        </a>
                      </li>
                    )}

                    {address.streetName && (
                      <li onClick={() => sendDataLayer(props.resellername, "map")}>
                        <svg aria-hidden="true">
                          <use href="/ui/images/sprites/brenderup.svg#street" />
                        </svg>
                        <a
                          href={`https://www.google.com/maps/?q=${address.latitude},${address.longitude}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {translate('dealerlocator.findhere')}
                        </a>
                      </li>
                    )}

                    <li
                      className="custom-checkbox"
                      onClick={() => sendDataLayer(props.resellername, "prefered")}
                    >
                      <input
                        className="prefer-address"
                        id={`prefer-${address.addressId}`}
                        type="checkbox"
                        checked={selectedInfo.addressId === address.addressId}
                        onChange={(event) =>
                          addPreferedAddress(event, address, index, props.markerId)
                        }
                      />
                      <label htmlFor={`prefer-${address.addressId}`}>
                        {translate('map.preferedretailer')}
                      </label>
                    </li>
                  </ul>
                </details>
              </div>

            </div>

          </li>
        ))}


    </Fragment>
  );
};

export default DealerListDetailTags;
